import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import { useAuth } from "../../components/contexts/AuthContext";
import "./admin.css";

export default function AdminNewsList() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadNews = () => {
    setLoading(true);
    api
      .getNews()
      .then(setNews)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadNews();
  }, []);

  const handleDelete = async (id, title) => {
    if (!window.confirm(`Удалить новость «${title}»?`)) {
      return;
    }

    try {
      await api.deleteNews(id);
      setNews((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <div>
          <h1>Новости</h1>
          <p className="admin-subtitle">{user?.email}</p>
        </div>
        <div className="admin-header-actions">
          <Link to="/admin/news/new" className="admin-btn admin-btn-primary">
            + Добавить
          </Link>
          <button type="button" className="admin-btn" onClick={logout}>
            Выйти
          </button>
        </div>
      </div>

      {loading && <p>Загрузка...</p>}
      {error && <p className="admin-error">{error}</p>}

      {!loading && !error && news.length === 0 && (
        <div className="admin-empty">
          <p>Новостей пока нет</p>
          <button
            type="button"
            className="admin-btn admin-btn-primary"
            onClick={() => navigate("/admin/news/new")}
          >
            Добавить первую новость
          </button>
        </div>
      )}

      {!loading && news.length > 0 && (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Заголовок</th>
                <th>Дата</th>
                <th>Теги</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {news.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.title}</td>
                  <td>{item.date}</td>
                  <td>{item.tags}</td>
                  <td className="admin-table-actions">
                    <Link to={`/admin/news/${item.id}/edit`}>Изменить</Link>
                    <button
                      type="button"
                      onClick={() => handleDelete(item.id, item.title)}
                    >
                      Удалить
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
